import React from 'react';
import Button from '../../Button/Button';
import HubspotContactForm from '../../HubspotContactForm';

function VymoInsights() {
  return (
        <section className="section-pad overflow-hidden vymo-insights md:mt-0">
             <div className="container mx-auto px-2 py-0">

                <div className="flex flex-col lg:flex-row items-center lg:items-start gap-0 md:gap-6 mt-2 md:mt-0">
                    <div className="text-left w-full md:w-1/2" data-aos="fade-up" data-aos-delay="100">
                        <div className="news-box py-[30px]">
                            <h3 className="text-left text-18 md:text-[42px] font-secondary font-bold text-white leading-[30px] md:leading-[48px] opacity-90 pb-0 md:pb-1">Get the latest Vymo insights delivered to your inbox</h3>
                            <p className="text-16 font-normal leading-6 text-left text-white opacity-90 pt-2">Join Vymo’s email list for weekly updates!
                            </p>
                            
                        </div>
                    </div>
                    <div className="text-left w-full md:w-1/2" data-aos="fade-up" data-aos-delay="200">
                        <div className="insights-box py-0 md:pr-6 pb-5 md:pb-0 md:mt-0 -mt-4">
                            <div id="hubspotForm"></div>
                            <HubspotContactForm 
                            region="na1"
                            portalId="43906338"
                            formId='afbe5ed2-9e5a-4360-b67d-f308ad453027'
                            />
                        </div>
                    </div>
                </div>

            </div>
        </section>
);
}

export default VymoInsights;